import styled from "styled-components";

const GenerationToast = ({ onClick, label = "View", successMessage }) => {
  return (
    <ToastWrapper>
      <Left>
        <IconWrap>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="19"
            height="19"
            viewBox="0 0 19 19"
            fill="none"
          >
            <path
              d="M5.41659 9.16634L7.91659 11.6663L12.9166 6.66634M17.4999 9.16634C17.4999 13.7687 13.769 17.4997 9.16659 17.4997C4.56421 17.4997 0.833252 13.7687 0.833252 9.16634C0.833252 4.56397 4.56421 0.833008 9.16659 0.833008C13.769 0.833008 17.4999 4.56397 17.4999 9.16634Z"
              stroke="white"
              strokeWidth="1.66667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </IconWrap>
        <Title>
          {successMessage ? successMessage : "Generation started.."}
        </Title>
      </Left>

      <Right onClick={onClick}>
        {label}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="7"
          height="12"
          viewBox="0 0 7 12"
          fill="none"
        >
          <path
            d="M0.833252 10.833L5.83325 5.83301L0.833252 0.833008"
            stroke="#4D9DFF"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </Right>
    </ToastWrapper>
  );
};

export default GenerationToast;

export const ToastWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  width: 100%;
  min-width: 250px;
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 8px;
`;

export const IconWrap = styled.div`
  display: flex;
  align-items: center;
  width: 20px;
  height: 20px;
  justify-content: center;
`;

export const Title = styled.div`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 300;
  letter-spacing: -0.408px;
`;

export const Right = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  justify-content: space-between;
  color: #4d9dff;
  cursor: pointer;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.408px;

  &:hover {
    opacity: 0.8;
  }
`;
